// START IMPORTS
import { useIsAccountInReactivationWithDaysLeft } from '@ltvco/refresh-lib/payments';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { useSession, GrowthbookWrapper } from '@ltvco/refresh-lib/v2';
import { useEffect, useState } from 'react';

import { ThemeWrapper } from './ThemeWrapper';
// END IMPORTS

export function Growthbook({ children }: { children: JSX.Element }) {
  // START HOOKS_AND_QUERIES
  const {
    session: { account, firstReportType },
  } = useSession();
  const { isMobile } = useScreenSize();

  const { isReady, isAccountInReactivationWithDaysLeft } =
    useIsAccountInReactivationWithDaysLeft();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [customAttributes, setCustomAttributes] = useState<
    Record<string, unknown>
  >({});
  const [isGbReady, setIsGbReady] = useState(false);
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const isTestingEnv = import.meta.env.VITE_IS_TEST;
  const deviceType = isMobile ? 'web-mobile' : 'desktop';
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    if (!account || !isReady) {
      return;
    }
    const justOneReportUsed =
      account?.account?.subscription_info?.monthly_reports_remaining ===
      account?.account?.subscription_info?.monthly_report_limit - 1;
    const isOnSignUpPlan =
      account?.account?.subscription_info?.in_signup_plan || false;
    const hasSinglePersonReport =
      firstReportType === 'person_report' &&
      justOneReportUsed &&
      isOnSignUpPlan;
    setCustomAttributes({
      'device-type': deviceType,
      pdf_access:
        !!account?.account?.subscription_info?.subscription_features
          ?.pdf_access,
      is_user_in_recycling: account?.account?.user_info?.user_in_recycling,
      is_user_mobile_subscription:
        account?.account?.subscription_info['mobile_subscription?'],
      has_single_person_report: hasSinglePersonReport,
      is_paused_user_with_days_left: isAccountInReactivationWithDaysLeft,
    });
  }, [account, firstReportType, isReady]);
  // END EFFECTS

  // START EARLY_RETURNS
  if (isTestingEnv) {
    return <ThemeWrapper isGbReady={isGbReady}>{children}</ThemeWrapper>;
  }
  // END EARLY_RETURNS

  // START RENDER
  return (
    <GrowthbookWrapper
      enableDevMode={true}
      apiHost={'https://gbbv.beenverified.com'}
      clientKey={'sdk-sH9Cly3zfuFM9mdc'}
      decryptionKey={'nZwGIW+xki4yOM6qBBx8Kg=='}
      subscribeToChanges={false}
      customAttributes={customAttributes}
      setIsGbReady={setIsGbReady}
      brandName={'beenverified'}
    >
      <ThemeWrapper isGbReady={isGbReady}>{children}</ThemeWrapper>
    </GrowthbookWrapper>
  );
  // END RENDER
}
